// services/formTriggerApi.js
import { apiBasePath } from "../constants/constants";
import ApiService from "../utils/api-service";



// Fetch triggers
export function getFormTriggers(formId) {
  return ApiService({
    method: "GET",
    url: `${apiBasePath}/formTriggers?formId=${formId}`,
    params: {},
  });
}

// Create trigger
export function createFormTrigger(data) {
  return ApiService({
    method: "POST",
    url: `${apiBasePath}/formTriggers`,
    data,
  });
}

// Update trigger
export function updateFormTrigger(data) {
  return ApiService({
    method: "PATCH",
    url: `${apiBasePath}/formTriggers`,
    data,
  });
}

export function deleteFormTrigger(formTriggerId) {
  return ApiService({
    method: "DELETE",
    url: `${apiBasePath}/formTriggers/${formTriggerId}`,
  });
}
export function sendReminderAPI(formTriggerId) {
  return ApiService({
    method: "POST",
    url: `${apiBasePath}/formTriggers/runFormTriggers?triggerId=${formTriggerId}`,
  });
}
